import { styled } from '@cp/ds/src/theme';
import { Box } from '@cp/ds/src/components/box';
import { name } from '../dialog/const';

export const InteractiveMessageLayout = styled(Box, { name, slot: 'InteractiveLayout' })(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: '50%',
  maxWidth: '90%',
  borderRadius: '12px',
  backgroundColor: theme.palette['gray light'],
  boxShadow: '0px 2.17px 3.25px 0px rgba(0, 0, 0, 0.1)',
  gap: theme.spacing(1),
  padding: theme.spacing(1.5),
  marginBlockEnd: theme.spacing(0.75),
}));
